import $ from 'jquery';

import BaseController from 'chairisher/_controller';
import BusinessImageViewer from 'chairisher/view/business/image/viewer';
import PortfolioFiltersView from 'chairisher/view/portfoliofilters';

import bindProfileAnalytics from 'chairisher/analytics/profile';

import { toggleDescription } from 'chairisher/util/collapse';

/**
 * Controller which binds actions for the business image list view.
 */
class BusinessImagePortfolioController extends BaseController {
    /** @inheritDoc */
    bindPageActions() {
        new BusinessImageViewer({
            $cards: $('.js-business-image-grid .js-card-image'),
        });

        $('.js-viewer-content').on('click', '.js-description-toggle', (e) => {
            toggleDescription(e);
        });

        new PortfolioFiltersView();
    }

    /** @inheritDoc */
    bindPageAnalytics() {
        super.bindPageAnalytics();
        bindProfileAnalytics('screen - portfolio');
    }
}

export default BusinessImagePortfolioController;
